<div class="select smardie-field-control" :class="{ 'is-disabled': disabled || readonly, error: error }">
  <select :class="{ 'centered' : centered, error: error }" v-model="selectedValue" :disabled="disabled || readonly">
    <option value="" :disabled="!defaultSelectable" v-if="defaultLabel">{{ defaultLabel }}</option>
    <template v-if="numbered">
      <template v-for="(item, key) in items" :key="'n-' + item.id">
        <option v-if="item.name" :value="item.id">{{ key + 1 }}.0 {{ item.name }}</option>
        <option v-else-if="item.description" :value="item.id">{{ key + 1 }}.0 {{ item.description }}</option>
      </template>
    </template>
    <template v-else>
      <template v-for="item in items" :key="'p-' + item.id">
        <option v-if="item.name" :value="item.id">{{ item.name }}</option>
        <option v-else-if="item.description" :value="item.id">{{ item.description }}</option>
      </template>
    </template>
  </select>
</div>
